<template>
    <div class="bg-white">
    
        <div>
            <CRow class="g-3">
                <CCol sm="6">
                    <CRow class="p-2">
                        <CCol sm="8"></CCol>
                        <CCol sm="4">
                            Logo
                        </CCol>
    
                    </CRow>
    
                    <CContainer style="max-width: 600px; text-align: left;">
                        <div>
                            <h3 class="custom-24px-600 font-color-171717 font-inter text-center mt-5">Welcome to Image Detector</h3>
                            <p class="custom-18px-500 text-center font-inter"><span class="font-color-666D80">Please sign-in to your account and start the adventures</span></p>
                        </div>
                        <div class="mt-5">
                            <CRow>
                                <CCol sm="12">
                                    <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-171717">Email</strong>
                                <CInput type="text" v-model="userEmail" />
                                </CCol>
                                <CCol sm="12">
                                    <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-171717">Password</strong>
                                <CInput type="password" v-model="userPassword" />
                                </CCol>
                                <CCol sm="6">
                                    <input type="checkbox"/><span class="font-color-171717 custom-14px-400 ml-2">Keep me logged in</span>
                                </CCol>
                                <CCol sm="6">
                                    <label class="custom-14px-500 font-color-064BB4 text-right" @click="GoToForgot()">Forgot Password</label>
                                </CCol>
                                <CCol sm="12">
                                    <div class="text-center mt-4 mb-2">
                                        <CButton class="button-Explore text-white bg-3A70EA border-8px" v-on:click="trylogin" block size="lg">Sign In</CButton>
                                    </div>
                                </CCol>
                                <CCol sm="12" class="text-center">
                            <p class="text-center custom-16px-500 font-color-171717 mt-3">New on our platform?<label class="font-color-3A70EA ml-2" @click="GoToSignUp()">Create an account</label></p>
                        </CCol>
                            </CRow>
                        </div>
                        <img src="../assets/img/icon/or.png" style="max-width:100%" class="mb-4 mt-4" />
                        <CRow>
                            <CCol sm="6">
                                <div class="custom-btn-white">
                            <div class="text-center" v-on:click="login">
                                <img src="../assets/img/icon/google1.png" alt="Google Login" style="max-width:20px" />
                                <span class="custom-14px-500 font-color-171717 ml-2">{{ lblGoogle }}</span>
                            </div>
                        </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="custom-btn-white">
                            <div class="text-center" v-on:click="login">
                                <img src="../assets/img/icon/fb.png" alt="Google Login" style="max-width:20px" />
                                <span class="custom-14px-500 font-color-171717 ml-2">{{ lblFb }}</span>
                            </div>
                        </div>
                            </CCol>
                        </CRow>
                       

                      
                      
                    </CContainer>
                </CCol>
                <CCol sm="6" lg="6">
                    <div>
                        <div style="background-position: center;background-size: cover; min-height: 100vh;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
                            <CContainer style="max-width: 600px; text-align: left;">
                                    <div>
                                        <br />
                                    <h3 class="custom-32px-700 text-white text-left">Logo</h3>
                                    <p class="custom-32px-600 text-white">Welcome to Image Detector: Your Gateway to Smarter Image Analysis</p>
                                    <p class="custom-18px-400 text-white" style="opacity:0.6">Discover how our cutting-edge platform transforms images into actionable insights to empower your decisions.</p>
                                </div>
                              
                            </CContainer>
                            <div class="text-right">
                                <img src="../assets/img/random/bgloginai.png" style="max-width:90%"/>
                            </div>
                        </div>
                    </div>
                </CCol>
            </CRow>
    
        </div>
    
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/random/bgloginblue.png";
import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";


import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '435242184873-lfkbjg7vnqp31opg3qgnn1u0pf0ve5kt.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout
    },

    data() {
        return {
            backgroundUrl: backgroundUrl,
            Email: "",
            Password: "",
            Error: false,
            lblGoogle: "Sign up with Google",
            lblFb: "Sign up with Facebook",
            lblApple: "Sign up with Apple",
            userPassword: "",
            userEmail: "",
            lblGoogle:"Google",
            lblFb: "Facebook"

        };
    },
    created() {
        AOS.init();
    },
    methods: {

        trylogin() {
            this.Error = false;

            const formData = new FormData();

            if (this.userEmail === "" || this.userPassword === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                formData.append("Email", this.userEmail);
                formData.append("Password", this.userPassword);

                this.$API
                    .post(this.$LoginToken, formData, { withCredentials: true })
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                        if (response.status == 200) {
                            if (response.data.status !== 400) {
                                this.$router.push("EventManagement");
                            
                                // if (response.data.data.userType === '-') {
                                //         this.$router.push("Profile");
                                //     } else if (response.data.data.userType === 'user') {
                                //         this.$router.push("Profile");
                                //     } else {
                                //         this.$router.push("Group");
                                //     }
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                    });
            }
        },
        async login() {
            this.lblGoogle = "Google";
            try {
                var googleuser = await this.$gAuth.signIn(); // Wait for signIn() method to complete
                this.isLogin = this.$gAuth.isAuthorized; // Update isLogin status after successful signIn
                console.log('Is user logged in?', this.isLogin);
                var idToken = googleuser.getAuthResponse().id_token;
                console.log("getProfile" + googleuser.getBasicProfile());
                console.log("auth" + googleuser.getAuthResponse());
                console.log("auth" + this.$gAuth.GoogleAuth.currentUser.get().getAuthResponse());




                // If the user is logged in, retrieve the user profile to access the email
                if (this.isLogin) {
                    console.log('ID Token:', idToken);

                    var authResponse = googleuser.getAuthResponse();
                    var accessToken = authResponse.access_token;
                    var idToken = authResponse.id_token;

                    console.log('ID Token:', idToken);
                    console.log('Access Token:', accessToken);

                    // Verify if the token includes the scope
                    await this.verifyScopes(accessToken);

                    // Fetch user phone and address info
                    const userInfo = await this.getUserInfo(accessToken);
                    console.log('User Info:', userInfo);

                    const userName = userInfo.displayName;
                    this.getUserEmail(idToken, userName);
                }
            } catch (error) {
                console.error('Error during login:', error);
            }
        },
        async verifyScopes(accessToken) {
            try {
                const response = await fetch(`https://www.googleapis.com/oauth2/v3/tokeninfo?access_token=${accessToken}`);
                const tokenInfo = await response.json();

                console.log('Token Info:', tokenInfo);

                if (tokenInfo.scope.includes('https://www.googleapis.com/auth/user.phonenumbers.read')) {
                    console.log('Scope is present in the token.');
                } else {
                    console.error('Scope is missing in the token.');
                }
            } catch (error) {
                console.error('Error verifying scopes:', error);
            }
        },
        async getUserInfo(accessToken) {
            try {
                const response = await fetch('https://people.googleapis.com/v1/people/me?personFields=phoneNumbers,addresses,emailAddresses,names', {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                const userData = await response.json();

                console.log('User Data:', userData);

                const phoneNumber = userData.phoneNumbers ?.length > 0 ? userData.phoneNumbers[0].value : 'No phone number available';
                const country = userData.addresses ?.length > 0 ? userData.addresses[0].country : 'No country information available';
                const displayName = userData.names ?.length > 0 ? userData.names[0].displayName : 'No display name available';

                return { phoneNumber, country, displayName };
            } catch (error) {
                console.error('Error fetching user info:', error);
                return { phoneNumber: 'Error', country: 'Error' };
            }
        },
        async getUserEmail(idToken, username) {
            this.lblGoogle = "Google";
            try {
                const response = await this.$API.get(this.$GetTokenEmail + "?idToken=" + idToken);
                if (response.status === 200) {
                    this.user = response.data;
                    this.SetSession(idToken, this.user, username);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToLoginType()
        {
            this.$router.push("LoginType");
        },
        GoToForgot()
        {
            this.$router.push("ResetPassword");
        },
        GoToSignUp()
        {
            this.$router.push("SignUp");

        }

    }

};
</script>

<style scoped>

</style>